import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idblab-footer.css.lit';
import '../../base/outline-link/outline-link';
import '../../base/outline-container/outline-container';
import '../../idb/idb-social-icons/idb-social-icons';
import '../../idb/idb-footer-logos/idb-footer-logos';
import { MobileController } from '../../controllers/mobile-controller';
import { classMap } from 'lit/directives/class-map.js';
/**
 * The IdbLabFooter component
 * @element idblab-footer
 * @slot primary - Primary footer menu.
 * @todo update with slots as needed
 */
@customElement('idblab-footer')
export class IdbLabFooter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  private mobileController = new MobileController(this, 'lg');

  render(): TemplateResult {
    const wrapperClasses = {
      mobile: this.mobileController.isMobile,
    };
    return html`
      <section class="footer">
        <div class="footer-navigation ${classMap(wrapperClasses)}">
          ${
            !this.mobileController.isMobile
              ? html`
          <outline-container ?x-padding="${!this.mobileController
            .isMobile}" ?y-padding="${!this.mobileController.isMobile}"
          >
            <slot name="primary"></slot>
          </outline-container>`
              : html`<slot name="primary"></slot>`
          }
        </div>
        <div class="footer-bottom--wrapper">
          <outline-container x-padding y-padding container-align="center">
            <div class="footer-bottom--content">
              <div class="footer-social">
                <idblab-social-icons></idblab-social-icons>
              </div>
              <div class="footer-logos">
                <idb-footer-logos></idb-footer-logos>
              </div>
            </div>
          </outline-container>
        </div>
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'idblab-footer': IdbLabFooter;
  }
}
